import React from "react";
import { statusToStepMap } from "../../../../constants/customer";

const steps = ["Confirmed","Scheduled", "Picked Up", "Processing", "Out For Delivery", "Delivered"];


export default function ProgressTracker({ status }) {
  // Find which step label matches this backend status
  console.log("status", status);
  const currentStepLabel = statusToStepMap[status] || steps[0];

  console.log("currentStepLabel", currentStepLabel);
  const currentStepIndex = steps.indexOf(currentStepLabel);

  console.log("currentStepIndex", currentStepIndex);
  return (
    <div className="flex items-center justify-between mb-10 w-full relative">
      {steps.map((step, index) => (
        <div key={index} className="relative flex flex-1 flex-col items-center">
          
          {/* Connector line between steps */}
          {index < steps.length - 1 && (
            <div
              className={`absolute top-2 left-1/2 w-full h-0.5 z-0 ${
                index < currentStepIndex ? "bg-green-600" : "bg-gray-300"
              }`}
            />
          )}

          {/* Step circle */}
          <div
            className={`w-4 h-4 rounded-full border-2 z-10 ${
              index <= currentStepIndex
                ? "bg-green-600 border-green-600"
                : "bg-white border-gray-400"
            }`}
          />

          {/* Label */}
          <span
            className={`mt-2 text-sm font-semibold ${
              index <= currentStepIndex ? "text-green-600" : "text-gray-400"
            }`}
          >
            {step}
          </span>
        </div>
      ))}
    </div>
  );
}
